import { useTranslation } from 'react-i18next';

import { StyledPersonaFieldName, StyledPersonaFieldValue, StylePersonaField } from './styles';

export const PersonaTooltipContent = ({ fields }: { fields: Array<{ labelKey: string; value: string[] }> }) => {
  const { t } = useTranslation();

  return (
    <>
      {fields.map(({ labelKey, value }) => (
        <StylePersonaField data-automation="PersonaTooltipField" key={labelKey}>
          <StyledPersonaFieldName data-automation="PersonaTooltipFieldName">
            {t(`contacts.persona.${labelKey}`)}:
          </StyledPersonaFieldName>
          <StyledPersonaFieldValue data-automation="PersonaTooltipFieldValue">
            {value.join(', ')}
          </StyledPersonaFieldValue>
        </StylePersonaField>
      ))}
    </>
  );
};
